import { createBrowserRouter } from "react-router-dom";
import AppContent from "../components/AppContent";
import Official from "../pages/official/Official";
import Manual from "../pages/manual/Manual";
import Mine from "../pages/mine/Mine";
// import ThreeScene from "../pages/threeScene/ThreeScene";

const router = createBrowserRouter([
    {
        path: '/',
        element: <Official />,
    },
    {
        path: '/:projectName',
        element: <AppContent />,
    },
    {
        path: '/manual',
        element: <Manual />,
    },
    {
        path: '/mine',
        element: <Mine />,
    },
    // {
    //     path: '/threeScene',
    //     element: <ThreeScene />,
    // }
]);

export default router;